if (!customElements.get('stitching-products')){
    customElements.define(
        'stitching-products',  class StitchingProductItem extends HTMLElement {
            constructor() {
                super();
                this.productMain = document.querySelector(".main-product--root")
                this.pathnameArray = window.location.pathname.split('/')
                this.sectionId = this.getAttribute("data-product-section-id")

                if (this.pathnameArray.length > 3){
                    this.pathnameArray.length = this.pathnameArray.length-2
                }else{
                    this.pathnameArray.length = this.pathnameArray.length-1
                }

                this.stitchingProducts = this.querySelectorAll("[data-stitching-product-item]")

                if(this.stitchingProducts.length > 0){
                    this.stitchingProducts.forEach(item => {
                        item.addEventListener("click", (event)=>{
                            const handle = item.getAttribute("data-product-handle")
                            this.fetchProduct(handle).then()
                        })
                    })
                }
            }
            async fetchProduct(handle){
                let fetchURL = ""

                if (this.pathnameArray.join('/').includes("collections") && !this.pathnameArray.join('/').includes("products")){
                    fetchURL = `${this.pathnameArray.join('/')}/products/${handle}?section_id=${this.sectionId}`
                }else{
                    fetchURL = `${this.pathnameArray.join('/')}/${handle}?section_id=${this.sectionId}`
                }


                await fetch(`${fetchURL}`)
                    .then(res=>res.text())
                    .then(data=>{
                        const parsed = new DOMParser().parseFromString(data, 'text/html')
                        this.productMain.innerHTML = parsed.querySelector('.main-product--root').innerHTML
                        const heading = document.querySelector("[data-block-type='heading'] [data-transition-item='viewport']")

                        if (heading) {
                            setTimeout(()=>{
                                heading.setAttribute("data-transition-active", "true")
                            }, 100)
                        }

                        if (this.pathnameArray.join('/').includes("collections")){
                            history.replaceState({}, "handle", `${this.pathnameArray.join('/')}` + `/products/${handle}`);
                        }else{
                            history.replaceState({}, "handle", `${this.pathnameArray.join('/')}` + `/${handle}`);
                        }
                    })
            }
        })
}
